module.exports = __webpack_public_path__ + "img/0.88639b7c.jpg";